import React from "react";
import { IconButton, Tooltip, Button } from "@mui/material";

const ActionMenu = ({ params, actions }) => {
  const visibleActions = actions.filter((action) => !action.disabled);

  return (
    <div style={{ display: "flex", gap: "8px" }}>
      {visibleActions.map((action, index) => (
        <Tooltip key={index} title={action.tooltip} arrow>
          {action.useButton ? (
            <Button
              variant="contained"
              size="small"
              onClick={() => action.onClick(params)}
            >
              {action.label}
            </Button>
          ) : (
            <IconButton onClick={() => action.onClick(params)}>
              {action.icon}
            </IconButton>
          )}
        </Tooltip>
      ))}
    </div>
  );
};

export default ActionMenu;
